"use client";

/* Perf pass: the floating, always-on widgets (StickyCTA,
 * ExitIntentPopup, LiveActivityWidget, CookieBanner) were already mount-
 * delayed via <DeferIdle> (aa952f5), but their CODE was still bundled into
 * the same initial chunk as everything else — DeferIdle only delays WHEN
 * React renders them, not when their JS is fetched/parsed.
 *
 * `next/dynamic(..., { ssr: false })` must live in a "use client" file (Next
 * forbids ssr:false inside a Server Component, which src/app/layout.tsx is)
 * — hence this dedicated wrapper. Combining both: DeferIdle still gates WHEN
 * rendering is attempted (idle-triggered), and dynamic() means that when
 * DeferIdle finally allows it, each widget's code arrives as its own
 * separate chunk fetch — never part of the initial page bundle at all.
 * None of these render SEO-relevant content, so ssr:false is safe for all five. */

import dynamic from "next/dynamic";
import { DeferIdle } from "@/components/marketing/DeferIdle";

const StickyCTA = dynamic(() => import("@/components/marketing/StickyCTA").then((m) => m.StickyCTA), { ssr: false });
const ExitIntentPopup = dynamic(() => import("@/components/marketing/ExitIntentPopup").then((m) => m.ExitIntentPopup), { ssr: false });
const LiveActivityWidget = dynamic(() => import("@/components/marketing/LiveActivityWidget").then((m) => m.LiveActivityWidget), { ssr: false });
const CookieBanner = dynamic(() => import("@/components/layout/CookieBanner").then((m) => m.CookieBanner), { ssr: false });

export function DeferredStickyCTA() {
  return (
    <DeferIdle>
      <StickyCTA />
    </DeferIdle>
  );
}

export function DeferredExitIntentPopup() {
  return (
    <DeferIdle>
      <ExitIntentPopup />
    </DeferIdle>
  );
}

export function DeferredLiveActivityWidget() {
  return (
    <DeferIdle>
      <LiveActivityWidget />
    </DeferIdle>
  );
}

export function DeferredCookieBanner() {
  return (
    <DeferIdle>
      <CookieBanner />
    </DeferIdle>
  );
}
